import { Button } from "reactstrap";
import { ButtonGroup } from "reactstrap";

export default function RenderButtonGroup<T>({
    data,
    value,
    setValue
}: {
    data: Array<{
        label: string;
        value: T;
    }>;
    value: T,
    setValue: (value: T) => void;
}) {
    return (
        <ButtonGroup>
            {
                data.map((item, i) => (
                    <Button
                        onClick={() => setValue(item.value)}
                        active={item.value === value}
                        key={i}
                    >
                        {item.label}
                    </Button>
                ))
            }
        </ButtonGroup>
    );
}